import translations from '../../config/translations'
import React from 'react'

/**
 * Example of usage:
 *
 * Basic usage, without parameters that needs to be replaced and standard locale (de)
 * i18n('form.checkbox.label.example_label')
 *
 *
 * Extended usage, with parameters but with standard locale (de)
 * The paramater needs to be added in the translation of every language like this: "This is a %parameterKey%"
 * It get's replaces by the given object. The keys are the parameterKey to identifiy it and the parameterKey will
 * be replaced with the parameterValue. The parameterKey should be unique. Otherwise it just will be replaced at
 * the first occurence.
 * i18n('form.checkbox.label.example_label', {parameterKey: parameterValue})
 *
 *
 * Extended usage, with no parameters but with given locale
 * Note that the second parameter is the paramters object so always deliver an empty object. NOT null, an empty string,
 * undefined or a number. As it get's type checked. You would get an empty string and an error in the console
 * i18n('form.checkbox.label.example_label', {}, 'en')
 *
 *
 * Extended usage, with parameters and given locale
 * i18n('form.checkbox.label.example_label', {parameterKey: parameterValue}, 'en')
 *
 * To see which locales are available check translations.js (located: src/config)
 *
 * @param id string
 * @param raw bool
 * @param locale string
 * @param parameters object
 * @returns string
 */
const i18n = (id, parameters = {}, raw = false,locale = 'de') => {
    let translation = ''

    if (!translations.hasOwnProperty(id) || !translations[id].hasOwnProperty(locale)) {
        console.error(`The requestest id (${id}) or language (${locale}) is not existing! Returning empty string!`)
        return translation
    }

    if (typeof parameters !== 'object') {
        console.error('Parameters is not an object! Returning empty string!')
        return translation
    }

    translation = translations[id][locale]
    const parameterKeys = Object.keys(parameters)

    if (parameterKeys.length > 0 && translation.includes('%')) {
        for (let i = 0; i < parameterKeys.length; i++) {
            const parameterKey = parameterKeys[i]
            translation = translation.replace(`%${parameterKey}%`, parameters[parameterKey])
        }
    } else if (parameterKeys.length > 0 && !translation.includes('%')) {
        console.warn('You have passed parameters to a translation which doesn\'t contain any! Returning translation!')
    }

    return raw ? <span dangerouslySetInnerHTML={{__html: translation}}/> : translation
}

export default i18n




// WEBPACK FOOTER //
// ./src/jsx/Utils/I18nUtil.jsx